import { IconWrapper } from '../runtime';
export default IconWrapper('link-format', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 24 24",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M0 3.75C0 1.67893 1.67893 0 3.75 0H20.25C22.3211 0 24 1.67893 24 3.75V20.25C24 22.3211 22.3211 24 20.25 24H3.75C1.67893 24 0 22.3211 0 20.25V3.75Z",
      "fill": 'url(#' + props.id + '7f701af2' + ')'
    }
  }), h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M16.8208 7.17915C15.9809 6.33924 14.6191 6.33921 13.7792 7.17908L13.4729 7.48533C12.6857 7.15326 11.8391 7.00558 10.9991 7.04229L12.3209 5.72061C13.9663 4.07534 16.6339 4.0754 18.2792 5.72074C19.9246 7.36613 19.9246 10.0338 18.2792 11.6792L15.7293 14.2291C14.0839 15.8745 11.4162 15.8745 9.77079 14.2291L9.31073 13.769L10.7691 12.3106L11.2292 12.7707C12.0691 13.6106 13.431 13.6106 14.2709 12.7707L16.8208 10.2208C17.6607 9.38087 17.6607 8.01908 16.8208 7.17915ZM8.27124 9.77103C9.9164 8.12613 12.5834 8.12606 14.2287 9.77087L14.6893 10.2314L13.231 11.6899L12.7704 11.2295C11.9307 10.3899 10.5693 10.3899 9.72954 11.2295L7.17932 13.7794C6.33936 14.6192 6.33931 15.9809 7.1792 16.8208C8.01907 17.6607 9.38076 17.6607 10.2206 16.8208L10.5266 16.5147C11.3137 16.8468 12.1601 16.9946 13 16.9581L11.6791 18.2791C10.0338 19.9245 7.36614 19.9246 5.72079 18.2792C4.0754 16.6339 4.07551 13.9661 5.72102 12.3208L8.27124 9.77103Z",
      "fill": "white"
    }
  }), h("defs", [h("linearGradient", {
    "attrs": {
      "id": props.id + '7f701af2',
      "x1": "0",
      "y1": "0",
      "x2": "24",
      "y2": "24",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [h("stop", {
    "attrs": {
      "stop-color": "#8497B8"
    }
  }), h("stop", {
    "attrs": {
      "offset": "1",
      "stop-color": "#60718D"
    }
  })])])]);
});